import { Component } from "@angular/core";
import { environment } from 'src/environments/environment';

@Component({
    standalone: false,
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {

  constructor() {}

  openTopdesk(): void {
    window.open(environment.topdeskUrl, '_blank');
  }

}